"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = __importDefault(require("color"));
var themeColors = {
    palette: {
        primaryP100: (0, color_1.default)('#ADF8FF'),
        primaryP200: (0, color_1.default)('#5CF1FF'),
        primaryP300: (0, color_1.default)('#05C3DE'),
        primaryP400: (0, color_1.default)('#00A8B8'),
        primaryP500: (0, color_1.default)('#007983'),
        primaryP600: (0, color_1.default)('#00707A'),
        primaryP700: (0, color_1.default)('#005E66'),
        primaryP800: (0, color_1.default)('#004B52'),
        primaryP900: (0, color_1.default)('#00383D'),
        secondaryS100: (0, color_1.default)('#F3F7CC'),
        secondaryS200: (0, color_1.default)('#E7EF99'),
        secondaryS300: (0, color_1.default)('#DCE666'),
        secondaryS400: (0, color_1.default)('#D0DE33'),
        secondaryS500: (0, color_1.default)('#C4D600'),
        secondaryS600: (0, color_1.default)('#AEBE00'),
        secondaryS700: (0, color_1.default)('#94A200'),
        secondaryS800: (0, color_1.default)('#7F8B00'),
        secondaryS900: (0, color_1.default)('#596100'),
        neutralsN100: (0, color_1.default)('#F9FAFB'),
        neutralsN200: (0, color_1.default)('#F4F6F8'),
        neutralsN300: (0, color_1.default)('#DFE3E8'),
        neutralsN400: (0, color_1.default)('#C4CDD5'),
        neutralsN500: (0, color_1.default)('#919EAB'),
        neutralsN600: (0, color_1.default)('#637381'),
        neutralsN700: (0, color_1.default)('#454F5B'),
        neutralsN800: (0, color_1.default)('#212B36'),
        neutralsN900: (0, color_1.default)('#161C24')
    },
    commonColors: {
        success: (0, color_1.default)('#6AD359'),
        warning: (0, color_1.default)('#FEDC00'),
        error: (0, color_1.default)('#DB0030'),
        errorHover: (0, color_1.default)('#720019'),
        white: (0, color_1.default)('#FFFFFF'),
        black: (0, color_1.default)('#000000'),
        backgroundMobile: (0, color_1.default)('#F7F9FA'),
        backgroundWeb: (0, color_1.default)('#F1F7F8')
    }
};
exports.default = themeColors;
//# sourceMappingURL=colorsV2.js.map